import React from 'react';
import { Chip } from '@mui/material';
import { LendingStatusBadgeEnum } from '../types';
import messages from '../messages.json';

export type LendingStatusBadgeProps = {
  statusBadge: LendingStatusBadgeEnum;
};
export function LendingStatusBadge({ statusBadge }: LendingStatusBadgeProps) {
  const chipProps = {
    sx: { cursor: 'inherit' },
    'data-testid': 'status-badge',
  };
  switch (statusBadge) {
    case LendingStatusBadgeEnum.APPROVED:
      return (
        <Chip
          label={messages.lendingStatusBadge.approvedLabel}
          size="small"
          variant="outlined"
          color="success"
          {...chipProps}
        />
      );
    case LendingStatusBadgeEnum.RECOMMENDED:
      return (
        <Chip
          label={messages.lendingStatusBadge.recommendedLabel}
          size="small"
          variant="outlined"
          color="success"
          {...chipProps}
        />
      );
    case LendingStatusBadgeEnum.APPROVED_COUNTER:
      return (
        <Chip
          label={messages.lendingStatusBadge.approvedCounterLabel}
          size="small"
          variant="outlined"
          color="success"
          {...chipProps}
        />
      );
    case LendingStatusBadgeEnum.COUNTER:
      return (
        <Chip
          label={messages.lendingStatusBadge.counterLabel}
          size="small"
          variant="outlined"
          {...chipProps}
          sx={{
            backgroundColor: 'var(--cc-cmdr-colorBadgeCounter)',
            borderColor: 'var(--cc-cmdr-colorBadgeCounterBorder)',
            cursor: 'inherit',
          }}
        />
      );
    case LendingStatusBadgeEnum.LOADING:
      return (
        <Chip
          label={messages.lendingStatusBadge.loadingLabel}
          size="small"
          variant="filled"
          color="default"
          {...chipProps}
        />
      );
    case LendingStatusBadgeEnum.DENIED:
      return (
        <Chip
          label={messages.lendingStatusBadge.deniedLabel}
          size="small"
          variant="outlined"
          color="error"
          {...chipProps}
        />
      );
    default:
      return null;
  }
}
